import React from "react";
import styles from "../../BorrowerDetails.module.css";
import { useBorrowerContext } from "../../store/borrower-details";
import CloseIcon from "@mui/icons-material/Close";
import { url } from "../../../../../App";
import { useState, useEffect } from "react";
import axios from "axios";
import CoapplicantDocument from "../SectionTwo/Components/Coapplicant/CoapplicantDocument";
import { ToastContainer, toast } from "react-toastify";
import CoapplicantMultiDocs from "../SectionTwo/Components/Coapplicant/CoapplicantMultiDocs";
import { useNavigate } from "react-router";
import Cookies from 'js-cookie';

const arrayOfObjects = [
  { fieldName: "coapplicant_pan", setState: "pan" },
  { fieldName: "coapplicant_selfphoto", setState: "selfPhoto" },
  { fieldName: "coapplicant_aadhar_front", setState: "aadharFront" },
  { fieldName: "coapplicant_aadhar_back", setState: "aadharBack" },
  { fieldName: "coapplicant_companyid", setState: "companyId" },
  { fieldName: "coapplicant_form60", setState: "form60" },
  { fieldName: "coapplicant_hr_confirmation_doc", setState: "hrConf" },
  { fieldName: "coapplicant_pf_letter", setState: "pfLetter" },
  { fieldName: "coapplicant_misc_doc", setState: "miscDocs" },
  { fieldName: "coapplicant_itr", setState: "itr" },
  { fieldName: "coapplicant_salaryslip", setState: "salarySlipped" },
  { fieldName: "coapplicant_signature_verification", setState: "bankVer" },
  { fieldName: "coapplicant_appointment_letter", setState: "appointmentLetter" },
  { fieldName: "coapplicant_milkstatement", setState: "milkStatement" },
  { fieldName: "coapplicant_inside_shop_photo", setState: "insidePhoto" },
  { fieldName: "coapplicant_electricity_bill", setState: "elecBill" },
  { fieldName: "coapplicant_bank_statement", setState: "bankStatement" },
  { fieldName: "borrower_epan", setState: "epan" },
  { fieldName: "borrower_digiaadhar", setState: "digiaadhar" },
  { fieldName: "borrower_aadharxml", setState: "aadharxml" },
  { fieldName: "borrower_edl", setState: "edl" },
  { fieldName: "coapplicant_driving_license", setState: "drivingLicense" },
  { fieldName: "coapplicant_ration_card", setState: "rationCard" },
  { fieldName: "coapplicant_election_card", setState: "electionCard" },
  { fieldName: "coapplicant_passport", setState: "passport" },
  { fieldName: "coapplicant_self_attested_kyc", setState: "selfKyc" },
  { fieldName: "coapplicant_rc", setState: "RC" },
  { fieldName: "coapplicant_bank_report_documents", setState: "bankReport" },
  { fieldName: "coapplicant_employeeid", setState: "employeeId" },
  { fieldName: "coapplicant_gst_certificate", setState: "gstCertificate" },
  { fieldName: "coapplicant_shop_certificate", setState: "shopCertificate" },
  { fieldName: "coapplicant_gumastadhara", setState: "gumastadhara" },
  { fieldName: "coapplicant_udhyam", setState: "udhyam" },
  { fieldName: "coapplicant_partnership_deed", setState: "partnershipDeed" },
  { fieldName: "coapplicant_company_registration_certificate", setState: "registrationCertificate" },
  { fieldName: "coapplicant_purchase_bill", setState: "purchaseBill" },
  { fieldName: "coapplicant_cibil_report", setState: "cibilReport" },
];

const CoapplicantDocumentsModal = ({
  closeModal,
  coapplicantDetails,
  closeLoader,
  openLoader,
  isDisbursed,
  isDownload, 
  isDelete
}) => {
  const { contextMenuHandler } = useBorrowerContext();
  console.log(coapplicantDetails);
  const Navigate = useNavigate();

  const [pan, setPan] = useState({
    doc: "",
    docType: "",
    apiName: "",
    location: "",
  });

  const [aadharFront, setAadharFront] = useState({
    doc: "",
    docType: "",
    location: "",
    apiName: "",
  });

  const [aadharBack, setAadharBack] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [selfie, setSelfie] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [form60, setForm60] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [companyId, setCompanyId] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [hrConf, setHrConf] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [pfLetter, setPfLetter] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [epan, setepan] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [digiaadhar, setdigiaadhar] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [aadharxml, setaadharxml] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [edl, setedl] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [drivingLicense, setDrivingLicense] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [rationCard, setRationCard] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  // const [electionCard, setElectionCard] = useState({
  //   doc: "",
  //   location: "",
  //   docType: "",
  //   apiName: "",
  // });

  const [passport, setPassport] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [rc, setRC] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [employeeId, setEmployeeId] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [shopCertificate, setShopCertificate] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [gumastadhara, setGumastadhara] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [udhyam, setUdhyam] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [partnershipDeed, setPartnershipDeed] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [registrationCertificate, setRegistrationCertificate] = useState({
    doc: "",
    location: "",
    docType: "",
    apiName: "",
  });

  const [docExist, setDocExist] = useState({
    pan: false,
    selfPhoto: false,
    aadharFront: false,
    aadharBack: false,
    companyId: false,
    form60: false,
    hrConf: false,
    pfLetter: false,
    miscDocs: false,
    itr: false,
    salarySlipped: false,
    bankVer: false,
    appointmentLetter: false,
    milkStatement: false,
    gstReturns: false,
    insidePhoto: false,
    outsidePhoto: false,
    elecBill: false,
    bankStatement: false,
    epan: false,
    digiaadhar: false,
    aadharxml: false,
    edl: false,
    drivingLicense: false,
    rationCard: false,
    electionCard: false,
    passport: false,
    selfKyc: false,
    RC: false,
    bankReport: false,
    employeeId: false,
    stockPhoto: false,
    gstCertificate: false,
    shopCertificate: false,
    gumastadhara: false,
    udhyam: false,
    partnershipDeed: false,
    registrationCertificate: false,
    purchaseBill: false,
    cibilReport: false
  });

  const [bankStatement, setBankStatement] = useState([]);
  const [miscDocs, setMiscDocs] = useState([]);
  const [itr, setItr] = useState([]);
  const [salarySlip, setSalarySlip] = useState([]);
  const [appointmentLetter, setAppointmentLetter] = useState([]);
  const [bankVer, setBankVar] = useState([]);
  const [milkStatement, setMilkStatement] = useState([]);
  const [insidePhoto, setInsidePhoto] = useState([]);
  const [elecBill, setElecBill] = useState([]);
  const [selfKyc, setSelfKyc] = useState([]);
  const [bankReport, setBankReport] = useState([]);
  const [gstCertificate, setGstCertificate] = useState([]);
  const [purchaseBill, setPurchaseBill] = useState([]);
  const [cibilReport, setCibilReport] = useState([]);
  const [electionCard, setElectionCard] = useState([]);

  const downloadCoapplicantDocsHandler = async (docName, docType, name) => {
    openLoader();
    try {
      const req = {
        token: Cookies.get('Token'),
        email: Cookies.get('Email'),
        coapplicant_id: coapplicantDetails.coapplicant_id,
        doc_name: docName,
        doc_type: docType,
        coapplicant_borrower_uniqueno: localStorage.getItem("uniqueID"),
      };
      const res = await axios.post(url + "/coapplicant/downloaddoc", req);
      if (!res.data.auth) {
        toast.error(res.data.message);
        closeLoader();
        return;
      }
      if (req.doc_type === "pdf") {
        const downloadLink = document.createElement("a");
        const linkSource = `data:application/${req.doc_type};base64,${res.data.doc_base64}`;
        const fileName = `${req.coapplicant_id} ${docName}.${req.doc_type}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        closeLoader();
      } else {
        const linkSource = `data:image/${req.doc_type};base64,${res.data.doc_base64}`;
        const downloadLink = document.createElement("a");
        const fileName = `${req.coapplicant_id} ${docName}.${req.doc_type}`;
        downloadLink.href = linkSource;
        downloadLink.download = fileName;
        downloadLink.click();
        closeLoader();
      }
    } catch (err) {
      console.log(err);
      closeLoader();
    }
  };

  const deleteCoapplicantHandler = async (docName, docType, location) => {
    let text = `Are you sure you want to delete ${docName} for ${coapplicantDetails.coapplicant_id}?`;
    if (!window.confirm(text)) {
      return;
    }
    try {
      const request = {
        token: Cookies.get('Token'),
        coapplicant_borrower_uniqueno: localStorage.getItem("uniqueID"),
        email: Cookies.get('Email'),
        coapplicant_id: coapplicantDetails.coapplicant_id,
        doc_arr: {
          location: location,
          doc_type: docType,
          doc_name: docName,
        },
      };
      console.log(request);
      const { data: response } = await axios.post(
        url + "/coapplicant/deletedoc",
        request
      );
      console.log(response);
      if (!response.auth) {
        toast.error(response.message);
        if (response.logout) {
          Navigate("/");
        }
        return;
      }
      toast.success(response.message);
      setTimeout(() => {
        window.location.reload();
      }, 2000);
      closeModal();
    } catch (err) {
      console.log(err);
      toast.error(err.message + "from console");
    }
  };

  useEffect(() => {
    const coapplicantDocumentHandler = async () => {
      arrayOfObjects.forEach(({ fieldName, setState }) => {
        const fieldVal = coapplicantDetails[fieldName];
        if (
          fieldVal &&
          (Array.isArray(fieldVal)
            ? fieldVal.length !== 0
            : Object.keys(fieldVal).length !== 0)
        ) {
          setDocExist((prevState) => ({
            ...prevState,
            [setState]: true,
          }));
        }
      });
      const fetchDocument = async (docName, docType) => {
        try {
          openLoader();
          const viewDocReq = {
            token: Cookies.get('Token'),
            email: Cookies.get('Email'),
            coapplicant_id: coapplicantDetails.coapplicant_id,
            doc_name: docName,
            doc_type: docType,
            coapplicant_borrower_uniqueno: localStorage.getItem("uniqueID"),
          };
          const viewDocRes = await axios.post(
            url + "/coapplicant/viewdoc",
            viewDocReq
          );
          closeLoader();
          if (!viewDocRes.data.auth) {
            // toast.error(viewDocRes.data.message);
            return null;
          }
          return viewDocRes.data.doc_base64;
        } catch (err) {
          console.error(err);
          closeLoader();
          return null;
        }
      };
      if (coapplicantDetails.coapplicant_pan) {
        try {
          const docName = coapplicantDetails.coapplicant_pan.doc_name;
          const docType = coapplicantDetails.coapplicant_pan.doc_type;
          const location = coapplicantDetails.coapplicant_pan.location;
          fetchDocument(docName, docType).then((doc) => {
            setPan((prevState) => ({
              ...prevState,
              docType: docType,
              doc: doc,
              apiName: docName,
              location: location,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_selfphoto) {
        try {
          const docType = coapplicantDetails.coapplicant_selfphoto.doc_type;
          const docName = coapplicantDetails.coapplicant_selfphoto.doc_name;
          const location = coapplicantDetails.coapplicant_selfphoto.location;
          fetchDocument(docName, docType).then((doc) => {
            setSelfie((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_aadhar_front) {
        try {
          const docType = coapplicantDetails.coapplicant_aadhar_front.doc_type;
          const location = coapplicantDetails.coapplicant_aadhar_front.location;
          const docName = coapplicantDetails.coapplicant_aadhar_front.doc_name;
          fetchDocument(docName, docType).then((doc) => {
            setAadharFront((prevState) => ({
              ...prevState,
              docType: docType,
              location: location,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_aadhar_back) {
        try {
          const location = coapplicantDetails.coapplicant_aadhar_back.location;
          const docType = coapplicantDetails.coapplicant_aadhar_back.doc_type;
          const docName = coapplicantDetails.coapplicant_aadhar_back.doc_name;
          fetchDocument(docName, docType).then((doc) => {
            setAadharBack((prevState) => ({
              ...prevState,
              docType: docType,
              location: location,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_form60) {
        try {
          const docType = coapplicantDetails.coapplicant_form60.doc_type;
          const location = coapplicantDetails.coapplicant_form60.location;
          const docName = coapplicantDetails.coapplicant_form60.doc_name;
          fetchDocument(docName, docType).then((doc) => {
            setForm60((prevState) => ({
              ...prevState,
              docType: docType,
              location: location,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_companyid) {
        try {
          const docType = coapplicantDetails.coapplicant_companyid.doc_type;
          const location = coapplicantDetails.coapplicant_companyid.location;
          const docName = coapplicantDetails.coapplicant_companyid.doc_name;
          fetchDocument(docName, docType).then((doc) => {
            setCompanyId((prevState) => ({
              ...prevState,
              docType: docType,
              location: location,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_hr_confirmation_doc) {
        try {
          const docType =
            coapplicantDetails.coapplicant_hr_confirmation_doc.doc_type;
          const location =
            coapplicantDetails.coapplicant_hr_confirmation_doc.location;
          const docName =
            coapplicantDetails.coapplicant_hr_confirmation_doc.doc_name;
          fetchDocument(docName, docType).then((doc) => {
            setHrConf((prevState) => ({
              ...prevState,
              docType: docType,
              location: location,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_pf_letter) {
        try {
          const docType = coapplicantDetails.coapplicant_pf_letter.doc_type;
          const location = coapplicantDetails.coapplicant_pf_letter.location;
          const docName = coapplicantDetails.coapplicant_pf_letter.doc_name;
          fetchDocument(docName, docType).then((doc) => {
            setPfLetter((prevState) => ({
              ...prevState,
              docType: docType,
              location: location,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_companyid) {
        try {
          const docType = coapplicantDetails.coapplicant_companyid.doc_type;
          const location = coapplicantDetails.coapplicant_companyid.location;
          const docName = coapplicantDetails.coapplicant_companyid.doc_name;
          fetchDocument(docName, docType).then((doc) => {
            setCompanyId((prevState) => ({
              ...prevState,
              docType: docType,
              location: location,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_misc_doc) {
        try {
          const coapplicantMiscDocsArr = await Promise.all(
            coapplicantDetails.coapplicant_misc_doc.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                docType: docType,
                apiName: docName,
                location: arr.location,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setMiscDocs(coapplicantMiscDocsArr);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_itr) {
        try {
          const coapplicantMiscDocsArr = await Promise.all(
            coapplicantDetails.coapplicant_itr.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                docType: docType,
                apiName: docName,
                location: arr.location,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setItr(coapplicantMiscDocsArr);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_salaryslip) {
        try {
          const coapplicantMiscDocsArr = await Promise.all(
            coapplicantDetails.coapplicant_salaryslip.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                docType: docType,
                apiName: docName,
                location: arr.location,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setSalarySlip(coapplicantMiscDocsArr);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_appointment_letter) {
        try {
          const coapplicantAppointmentLetter = await Promise.all(
            coapplicantDetails.coapplicant_appointment_letter.map(
              async (arr) => {
                const docName = arr.doc_name;
                const docType = arr.doc_type;
                return {
                  doc: await fetchDocument(docName, docType),
                  docType: docType,
                  apiName: docName,
                  location: arr.location,
                  download: downloadCoapplicantDocsHandler,
                };
              }
            )
          );
          setAppointmentLetter(coapplicantAppointmentLetter);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_signature_verification) {
        try {
          const coapplicantMiscDocsArr = await Promise.all(
            coapplicantDetails.coapplicant_signature_verification.map(
              async (arr) => {
                const docName = arr.doc_name;
                const docType = arr.doc_type;
                return {
                  doc: await fetchDocument(docName, docType),
                  docType: docType,
                  apiName: docName,
                  location: arr.location,
                  download: downloadCoapplicantDocsHandler,
                };
              }
            )
          );
          setBankVar(coapplicantMiscDocsArr);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_milkstatement) {
        try {
          const coapplicantMilkStatement = await Promise.all(
            coapplicantDetails.coapplicant_milkstatement.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                docType: docType,
                apiName: docName,
                location: arr.location,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setMilkStatement(coapplicantMilkStatement);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_inside_shop_photo) {
        try {
          const responseArr = await Promise.all(
            coapplicantDetails.coapplicant_inside_shop_photo.map(
              async (arr) => {
                const docName = arr.doc_name;
                const docType = arr.doc_type;
                return {
                  doc: await fetchDocument(docName, docType),
                  docType: docType,
                  apiName: docName,
                  location: arr.location,
                  download: downloadCoapplicantDocsHandler,
                };
              }
            )
          );
          setInsidePhoto(responseArr);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_electricity_bill) {
        try {
          const coapplicantElectricityBill = await Promise.all(
            coapplicantDetails.coapplicant_electricity_bill.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                docType: docType,
                apiName: docName,
                location: arr.location,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setElecBill(coapplicantElectricityBill);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_bank_statement) {
        try {
          const coapplicantBankStatement = await Promise.all(
            coapplicantDetails.coapplicant_bank_statement.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                location: arr.location,
                docType: docType,
                apiName: docName,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setBankStatement(coapplicantBankStatement);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.borrower_epan) {
        try {
          const docName = coapplicantDetails.borrower_epan.doc_name;
          const docType = coapplicantDetails.borrower_epan.doc_type;
          const location = coapplicantDetails.borrower_epan.location;
          fetchDocument(docName, docType).then((doc) => {
            setepan((prevState) => ({
              ...prevState,
              docType: docType,
              doc: doc,
              apiName: docName,
              location: location,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.borrower_digiaadhar) {
        try {
          const docName = coapplicantDetails.borrower_digiaadhar.doc_name;
          const docType = coapplicantDetails.borrower_digiaadhar.doc_type;
          const location = coapplicantDetails.borrower_digiaadhar.location;
          fetchDocument(docName, docType).then((doc) => {
            setdigiaadhar((prevState) => ({
              ...prevState,
              docType: docType,
              doc: doc,
              apiName: docName,
              location: location,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.borrower_aadharxml) {
        try {
          const docName = coapplicantDetails.borrower_aadharxml.doc_name;
          const docType = coapplicantDetails.borrower_aadharxml.doc_type;
          const location = coapplicantDetails.borrower_aadharxml.location;
          fetchDocument(docName, docType).then((doc) => {
            setaadharxml((prevState) => ({
              ...prevState,
              docType: docType,
              doc: doc,
              apiName: docName,
              location: location,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.borrower_edl) {
        try {
          const docName = coapplicantDetails.borrower_edl.doc_name;
          const docType = coapplicantDetails.borrower_edl.doc_type;
          const location = coapplicantDetails.borrower_edl.location;
          fetchDocument(docName, docType).then((doc) => {
            setedl((prevState) => ({
              ...prevState,
              docType: docType,
              doc: doc,
              apiName: docName,
              location: location,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_driving_license) {
        try {
          const docType = coapplicantDetails.coapplicant_driving_license.doc_type;
          const docName = coapplicantDetails.coapplicant_driving_license.doc_name;
          const location = coapplicantDetails.coapplicant_driving_license.location;
          fetchDocument(docName, docType).then((doc) => {
            setDrivingLicense((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_ration_card) {
        try {
          const docType = coapplicantDetails.coapplicant_ration_card.doc_type;
          const docName = coapplicantDetails.coapplicant_ration_card.doc_name;
          const location = coapplicantDetails.coapplicant_ration_card.location;
          fetchDocument(docName, docType).then((doc) => {
            setRationCard((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_election_card) {
        try {
          const coapplicantElectionCard = await Promise.all(
            coapplicantDetails.coapplicant_election_card.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                location: arr.location,
                docType: docType,
                apiName: docName,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setElectionCard(coapplicantElectionCard);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_passport) {
        try {
          const docType = coapplicantDetails.coapplicant_passport.doc_type;
          const docName = coapplicantDetails.coapplicant_passport.doc_name;
          const location = coapplicantDetails.coapplicant_passport.location;
          fetchDocument(docName, docType).then((doc) => {
            setPassport((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_self_attested_kyc) {
        try {
          const coapplicantSelfKycArr = await Promise.all(
            coapplicantDetails.coapplicant_self_attested_kyc.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                location: arr.location,
                docType: docType,
                apiName: docName,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setSelfKyc(coapplicantSelfKycArr);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_rc) {
        try {
          const docType = coapplicantDetails.coapplicant_rc.doc_type;
          const docName = coapplicantDetails.coapplicant_rc.doc_name;
          const location = coapplicantDetails.coapplicant_rc.location;
          fetchDocument(docName, docType).then((doc) => {
            setRC((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        }
        catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_bank_report_documents) {
        try {
          const coapplicantBankReport = await Promise.all(
            coapplicantDetails.coapplicant_bank_report_documents.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                location: arr.location,
                docType: docType,
                apiName: docName,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setBankReport(coapplicantBankReport);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_employeeid) {
        try {
          const docType = coapplicantDetails.coapplicant_employeeid.doc_type;
          const docName = coapplicantDetails.coapplicant_employeeid.doc_name;
          const location = coapplicantDetails.coapplicant_employeeid.location;
          fetchDocument(docName, docType).then((doc) => {
            setEmployeeId((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_shop_certificate) {
        try {
          const docType = coapplicantDetails.coapplicant_shop_certificate.doc_type;
          const docName = coapplicantDetails.coapplicant_shop_certificate.doc_name;
          const location = coapplicantDetails.coapplicant_shop_certificate.location;
          fetchDocument(docName, docType).then((doc) => {
            setShopCertificate((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_gumastadhara) {
        try {
          const docType = coapplicantDetails.coapplicant_gumastadhara.doc_type;
          const docName = coapplicantDetails.coapplicant_gumastadhara.doc_name;
          const location = coapplicantDetails.coapplicant_gumastadhara.location;
          fetchDocument(docName, docType).then((doc) => {
            setGumastadhara((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_udhyam) {
        try {
          const docType = coapplicantDetails.coapplicant_udhyam.doc_type;
          const docName = coapplicantDetails.coapplicant_udhyam.doc_name;
          const location = coapplicantDetails.coapplicant_udhyam.location;
          fetchDocument(docName, docType).then((doc) => {
            setUdhyam((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_partnership_deed) {
        try {
          const docType = coapplicantDetails.coapplicant_partnership_deed.doc_type;
          const docName = coapplicantDetails.coapplicant_partnership_deed.doc_name;
          const location = coapplicantDetails.coapplicant_partnership_deed.location;
          fetchDocument(docName, docType).then((doc) => {
            setPartnershipDeed((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_company_registration_certificate) {
        try {
          const docType = coapplicantDetails.coapplicant_company_registration_certificate.doc_type;
          const docName = coapplicantDetails.coapplicant_company_registration_certificate.doc_name;
          const location = coapplicantDetails.coapplicant_company_registration_certificate.location;
          fetchDocument(docName, docType).then((doc) => {
            setRegistrationCertificate((prevState) => ({
              ...prevState,
              location: location,
              docType: docType,
              doc: doc,
              apiName: docName,
            }));
          });
        } catch (err) {
          console.error(err);
          return null;
        }
      }
      if (coapplicantDetails.coapplicant_gst_certificate) {
        try {
          const coapplicantGstCerti = await Promise.all(
            coapplicantDetails.coapplicant_gst_certificate.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                location: arr.location,
                docType: docType,
                apiName: docName,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setGstCertificate(coapplicantGstCerti);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_purchase_bill) {
        try {
          const coapplicantPurchaseBill = await Promise.all(
            coapplicantDetails.coapplicant_purchase_bill.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                location: arr.location,
                docType: docType,
                apiName: docName,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setPurchaseBill(coapplicantPurchaseBill);
        } catch (err) {
          console.error(err);
        }
      }
      if (coapplicantDetails.coapplicant_cibil_report) {
        try {
          const coapplicantCibilReport = await Promise.all(
            coapplicantDetails.coapplicant_cibil_report.map(async (arr) => {
              const docName = arr.doc_name;
              const docType = arr.doc_type;
              return {
                doc: await fetchDocument(docName, docType),
                location: arr.location,
                docType: docType,
                apiName: docName,
                download: downloadCoapplicantDocsHandler,
              };
            })
          );
          setCibilReport(coapplicantCibilReport);
        } catch (err) {
          console.error(err);
        }
      }
    };
    coapplicantDocumentHandler();
    // eslint-disable-next-line
  }, [
    coapplicantDetails.coapplicant_id,
    coapplicantDetails.coapplicant_pan,
    coapplicantDetails.coapplicant_self_photo,
    coapplicantDetails.coapplicant_aadhar_front,
    coapplicantDetails.coapplicant_aadhar_back,
    coapplicantDetails.coapplicant_form60,
    coapplicantDetails.coapplicant_misc_doc,
    coapplicantDetails.coapplicant_bank_statement,
    coapplicantDetails.borrower_epan,
    coapplicantDetails.borrower_digiaadhar,
    coapplicantDetails.borrower_aadharxml,
    coapplicantDetails.borrower_edl,
    coapplicantDetails.coapplicant_driving_license,
    coapplicantDetails.coapplicant_ration_card,
    coapplicantDetails.coapplicant_election_card,
    coapplicantDetails.coapplicant_passport,
    coapplicantDetails.coapplicant_self_attested_kyc,
    coapplicantDetails.coapplicant_rc,
    coapplicantDetails.coapplicant_bank_report_documents,
    coapplicantDetails.coapplicant_employeeid,
    coapplicantDetails.coapplicant_shop_certificate,
    coapplicantDetails.coapplicant_gumastadhara,
    coapplicantDetails.coapplicant_udhyam,
    coapplicantDetails.coapplicant_partnership_deed,
    coapplicantDetails.coapplicant_company_registration_certificate,
    coapplicantDetails.coapplicant_gst_certificate,
    coapplicantDetails.coapplicant_purchase_bill,
    coapplicantDetails.coapplicant_cibil_report,
    coapplicantDetails.coapplicant_electricity_bill,
    coapplicantDetails.coapplicant_milkstatement,
    coapplicantDetails.coapplicant_appointment_letter,
  ]);

  return (
    <>
      <ToastContainer />
      <div className={styles.coapplicantDocumentsModal}>
        <div
          className={styles.coapplicantDocumentsModaOverlay}
          onClick={(e) => e.target === e.currentTarget && closeModal()}
        >
          <div
            className={styles.coapplicantDocumentsModalContent}
            onContextMenu={contextMenuHandler}
          >
            <h3>Coapplicant Documents</h3>
            {docExist.selfPhoto && (
              <CoapplicantDocument
                name={"Self Photo"}
                deleteDoc={deleteCoapplicantHandler}
                doc={selfie.doc}
                docType={selfie.docType}
                apiName={selfie.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                coapplicantDetails={coapplicantDetails}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.pan && (
              <CoapplicantDocument
                name={"PAN"}
                doc={pan.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={pan.docType}
                apiName={pan.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.form60 && (
              <CoapplicantDocument
                name={"Form 60"}
                doc={form60.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={form60.docType}
                apiName={form60.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.aadharFront && (
              <CoapplicantDocument
                deleteDoc={deleteCoapplicantHandler}
                name={"Aadhar Front"}
                doc={aadharFront.doc}
                docType={aadharFront.docType}
                apiName={aadharFront.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.aadharBack && (
              <CoapplicantDocument
                name={"Aadhar Back"}
                doc={aadharBack.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={aadharBack.docType}
                apiName={aadharBack.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.drivingLicense && (
              <CoapplicantDocument
                name={"Driving License"}
                doc={drivingLicense.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={drivingLicense.docType}
                apiName={drivingLicense.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.rationCard && (
              <CoapplicantDocument
                name={"Ration Card"}
                doc={rationCard.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={rationCard.docType}
                apiName={rationCard.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {console.log("electionCard-> ",electionCard)}
            {console.log("docExist.electionCard-> ",docExist.electionCard)}

            {docExist.electionCard && (

           
                // <CoapplicantDocument
                //   name={"Election Card"}
                //   doc={electionCard.doc}
                //   deleteDoc={deleteCoapplicantHandler}
                //   docType={electionCard.docType}
                //   apiName={electionCard.apiName}
                //   download={downloadCoapplicantDocsHandler}
                //   isDisbursed={isDisbursed}
                // />
                <CoapplicantMultiDocs
                  name={"Election Card"}
                  doc={electionCard}
                  deleteDoc={deleteCoapplicantHandler}
                  download={downloadCoapplicantDocsHandler}
                  isDisbursed={isDisbursed}
                />

            )}
            {docExist.passport && (
              <CoapplicantDocument
                name={"Passport"}
                doc={passport.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={passport.docType}
                apiName={passport.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.selfKyc && (
              <CoapplicantMultiDocs
                name={"Self Attested Kyc"}
                doc={selfKyc}
                deleteDoc={deleteCoapplicantHandler}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.RC && (
              <CoapplicantDocument
                name={"RC"}
                doc={rc.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={rc.docType}
                apiName={rc.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.bankStatement && (
              <CoapplicantMultiDocs
                name={"Bank Statement"}
                doc={bankStatement}
                deleteDoc={deleteCoapplicantHandler}
                download={downloadCoapplicantDocsHandler}
                pdfPassword={
                  coapplicantDetails?.coapplicant_bank_statement_password
                }
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.bankReport && (
              <CoapplicantMultiDocs
                name={"Bank Report"}
                doc={bankReport}
                deleteDoc={deleteCoapplicantHandler}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.itr && (
              <CoapplicantMultiDocs
                name={"ITR"}
                deleteDoc={deleteCoapplicantHandler}
                doc={itr}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.salarySlipped && (
              <CoapplicantMultiDocs
                name={"Salary Slip"}
                deleteDoc={deleteCoapplicantHandler}
                doc={salarySlip}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.bankVer && (
              <CoapplicantMultiDocs
                name={"Bank Signature Verification"}
                deleteDoc={deleteCoapplicantHandler}
                doc={bankVer}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.companyId && (
              <CoapplicantDocument
                name={"Company ID"}
                doc={companyId.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={companyId.docType}
                apiName={companyId.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.appointmentLetter && (
              <CoapplicantMultiDocs
                name={"Appointment Letter"}
                deleteDoc={deleteCoapplicantHandler}
                doc={appointmentLetter}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.employeeId && (
              <CoapplicantDocument
                name={"Employee Id"}
                doc={employeeId.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={employeeId.docType}
                apiName={employeeId.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.hrConf && (
              <CoapplicantDocument
                name={"HR Confirmation"}
                doc={hrConf.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={hrConf.docType}
                apiName={hrConf.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.pfLetter && (
              <CoapplicantDocument
                name={"PF Letter"}
                doc={pfLetter.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={pfLetter.docType}
                apiName={pfLetter.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.elecBill && (
              <CoapplicantMultiDocs
                name={"Electricity Bill"}
                deleteDoc={deleteCoapplicantHandler}
                doc={elecBill}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.milkStatement && (
              <CoapplicantMultiDocs
                name={"Milk Statement"}
                deleteDoc={deleteCoapplicantHandler}
                doc={milkStatement}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.insidePhoto && (
              <CoapplicantMultiDocs
                name={"Business Photo"}
                deleteDoc={deleteCoapplicantHandler}
                doc={insidePhoto}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.gstCertificate && (
              <CoapplicantMultiDocs
                name={"GST certificate"}
                deleteDoc={deleteCoapplicantHandler}
                doc={gstCertificate}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.shopCertificate && (
              <CoapplicantDocument
                name={"Shop Certificate"}
                doc={shopCertificate.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={shopCertificate.docType}
                apiName={shopCertificate.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.gumastadhara && (
              <CoapplicantDocument
                name={"Gumastadhara"}
                doc={gumastadhara.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={gumastadhara.docType}
                apiName={gumastadhara.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.udhyam && (
              <CoapplicantDocument
                name={"Udhyam"}
                doc={udhyam.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={udhyam.docType}
                apiName={udhyam.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.partnershipDeed && (
              <CoapplicantDocument
                name={"Partnership Deed"}
                doc={partnershipDeed.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={partnershipDeed.docType}
                apiName={partnershipDeed.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.registrationCertificate && (
              <CoapplicantDocument
                name={"Company Registration Certificate"}
                doc={registrationCertificate.doc}
                deleteDoc={deleteCoapplicantHandler}
                docType={registrationCertificate.docType}
                apiName={registrationCertificate.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.purchaseBill && (
              <CoapplicantMultiDocs
                name={"Purchase Bill"}
                deleteDoc={deleteCoapplicantHandler}
                doc={purchaseBill}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.miscDocs && (
              <CoapplicantMultiDocs
                name={"Misc Docs"}
                deleteDoc={deleteCoapplicantHandler}
                doc={miscDocs}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.cibilReport && (
              <CoapplicantMultiDocs
                name={"Cibil Report"}
                deleteDoc={deleteCoapplicantHandler}
                doc={cibilReport}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.epan && (
              <CoapplicantDocument
                name={"e-PAN (Digilocker)"}
                deleteDoc={deleteCoapplicantHandler}
                doc={epan.doc}
                docType={epan.docType}
                apiName={epan.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.digiaadhar && (
              <CoapplicantDocument
                name={"e-Aadhar (Digilocker)"}
                deleteDoc={deleteCoapplicantHandler}
                doc={digiaadhar.doc}
                docType={digiaadhar.docType}
                apiName={digiaadhar.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.aadharxml && (
              <CoapplicantDocument
                name={"e-Aadhar XML (Digilocker)"}
                deleteDoc={deleteCoapplicantHandler}
                doc={aadharxml.doc}
                docType={aadharxml.docType}
                apiName={aadharxml.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            {docExist.edl && (
              <CoapplicantDocument
                name={"e-Driving License (Digilocker)"}
                deleteDoc={deleteCoapplicantHandler}
                doc={edl.doc}
                docType={edl.docType}
                apiName={edl.apiName}
                download={downloadCoapplicantDocsHandler}
                isDisbursed={isDisbursed}
                isDownload={isDownload}
                isDelete={isDelete}
              />
            )}
            <CloseIcon className={styles.CloseIcon} onClick={closeModal} />
          </div>
        </div>
      </div>
    </>
  );
};

export default CoapplicantDocumentsModal;
